import {calculateNeededSpaceForSidebarCards, canAllSidebarCardsFitOnScreen} from '../../../utils';
import useReport from '../../providers/useReport';
import {useIsModuleVisibleOrEnabled} from '../report-modules/useIsModuleVisibleOrEnabled/useIsModuleVisibleOrEnabled';

export function useSidebarDisplayLogic(containerHeight) {
  const {reports} = useReport();
  const {getNumberOfVisibleModulesCategories} = useIsModuleVisibleOrEnabled();

  const numberOfModulesCategoriesToDisplay = getNumberOfVisibleModulesCategories();
  const numberOfReportsToDisplay = reports.length;

  const totalHeightNeededForReportsDisplaying = calculateNeededSpaceForSidebarCards(numberOfReportsToDisplay);
  const totalNumberOfItemsToDisplay = numberOfModulesCategoriesToDisplay + numberOfReportsToDisplay;

  const shouldDisplayPanes = !canAllSidebarCardsFitOnScreen(containerHeight, totalNumberOfItemsToDisplay);
  const shouldDisplayOnlyMoreButtons = containerHeight < 200;

  return {
    totalHeightNeededForReportsDisplaying,
    shouldDisplayPanes,
    shouldDisplayOnlyMoreButtons,
    numberOfReportsToDisplay
  };
}
